// If you use the darkMode: "selector" setting in Tailwind, add this controller to your body tag <body data-controller="dark-mode" and it should toggle based on an event you might want to declare. This is commonly a dropdown or something that displays ['light', 'dark', 'system'].

// Changes are saved to local storage to persist the setting.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // User-controlled theme — no system preference listener. Whatever they
    // last picked (stored in localStorage) wins. Default to dark if no
    // preference has been set.
    if (localStorage.theme === "light") {
      this.setLightMode()
    } else {
      this.setDarkMode()
    }
  }

  toggle() {
    if (document.documentElement.classList.contains("dark")) {
      this.setLightMode()
    } else {
      this.setDarkMode()
    }
  }

  setDarkMode() {
    document.documentElement.classList.add("dark")
    document.documentElement.setAttribute("data-theme", "dark")
    localStorage.theme = "dark"
    document.cookie = "theme=dark; path=/; max-age=31536000; samesite=lax"
  }

  setLightMode() {
    document.documentElement.classList.remove("dark")
    document.documentElement.setAttribute("data-theme", "light")
    localStorage.theme = "light"
    document.cookie = "theme=light; path=/; max-age=31536000; samesite=lax"
  }

  setSystemMode() {
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)")

    if (prefersDark.matches) {
      this.setDarkMode()
    } else {
      this.setLightMode()
    }

    delete localStorage.theme
    // Cookie stays set to current effective theme so server-rendered content (e.g. Stripe drawer) gets correct theme
  }
}
